import {
  SearchSortField,
  SearchSortDirection,
  MemberDependentRelationship,
  MemberDependentGender,
  MemberDependentStatus,
  MemberListSearchRequestStatus,
  MemberInfoResponseStatus
} from '@benefitsui/app/api/benefits-clients';

export interface MemberInfo {
  employeeId: string;
  contractId: string;
  employeeName: string;
  firstName: string;
  lastName: string;
  applicantName: string;
  dob: string;
  status: MemberInfoResponseStatus;
  coverage: string;
  billingDivision: string;
  indicator: string | undefined;
}

export interface MemberData {
  totalResults: number;
  listMember: MemberInfo[];
}

export type MemberListSearchParameters = {
  groupId: string | undefined;
  policyId: string | undefined;
  employeeName: string | undefined;
  status: MemberListSearchRequestStatus;
  billingDivision: string | undefined;
  page: number;
  pageSize: number;
  sortField: SearchSortField;
  sortDirection: SearchSortDirection;
};

export interface CoverageTableData {
  description: string;
  class: string;
  benefit: string;
  premium: string;
  effectiveDate: string;
  terminationDate?: string;
  dependents?: string[];
}

export interface EmployeeData {
  fullName: string;
  firstName: string;
  lastName: string;
  birthdate: string;
  gender: string;
  status?: string;
  statusColor?: string;
  occupation: string;
  ssn: string;
  salary?: string;
  hireDate: string;
  smokerStatus?: string;
  billDivision?: string;
  billDivisionNumber: string;
}

export interface DependentData {
  fullName: string;
  firstName: string;
  lastName: string;
  birthdate: string;
  gender: MemberDependentGender;
  status: MemberDependentStatus;
  coverageStatus: CoverageStatus;
  statusColor: string;
  ssn: string;
  relationship: MemberDependentRelationship;
  smokerStatus?: boolean;
  smokerStatusString: string;
  student?: string;
  disabled?: string;
}

export enum CoverageStatus {
  Active = 'Active',
  InActive = 'Inactive',
  PlannedTermination = 'Planned termination',
  Unknown = '',
  Leave = 'Leave',
  Terminated = 'Terminated'
}

export enum CoverageBucketCodes {
  LifeAdd = '01',
  Disability = '02',
  Absence = '03'
}
